export default __webpack_public_path__ + "static/media/T344_T346_D_BD.78330219.pdf";